import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=4b22533d"
var script = {}
import style0 from "./Content.vue?vue&type=style&index=0&id=4b22533d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports